// src/utils/auth.js
// Authentication utility functions

export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return false;
  }

  // Optional: Add token expiration check if your backend uses JWT
  try {
    // If you're using JWT, decode and check expiration
    const payload = JSON.parse(atob(token.split('.')[1]));
    const isExpired = payload.exp * 1000 < Date.now();
    
    if (isExpired) {
      localStorage.removeItem('token');
      return false;
    }
    
    return true;
  } catch (error) {
    // If token is malformed, consider it invalid
    localStorage.removeItem('token');
    return false;
  }
};

export const clearAuth = () => {
  localStorage.removeItem('token');
  sessionStorage.clear();
};